// Full-document render of the anonymous order-STATUS page
// (/orders/<number>/<hash>/): PageSkeleton wrapping the legacy sealy body. The
// track_order_lookup dataLayer events push after hydration.
import React from "react";
import { DataLayerPush } from "tsi-common-react/src/components/DataLayerPush/index";

import { templates } from "@reactivated";

import { AnonOrderPageBody } from "../components/AnonOrderPageBody";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.AnonOrderDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <AnonOrderPageBody {...props} />
        <DataLayerPush events={props.ga_events} />
    </PageSkeleton>
);
